import { QueryParams } from 'APIs/types';
import { DateFilterQueryInput, DateFilterValue, toInstantFilterInput } from 'Components/Common/Filters/DateFilter';
import { MultiSelectFilterValue } from 'Components/Common/Filters/MultiSelectFilter';
import { TextFilterValue } from 'Components/Common/Filters/TextFilter';
import { FilterOption } from 'Components/Common/Filters/types';

export const initFilterOptions: FilterOption[] = [
  {
    option_id: 'event_type',
    checked: false,
    value: null,
    label: 'Event Type',
    optionType: 'multi_select',
    optionConfig: {
      options: [
        { value: 'CardBlockAdded', label: 'Block added' },
        { value: 'CardBlockEnforced', label: 'Block enforced' },
        { value: 'CardBlockRemoved', label: 'Block removed' },
      ],
    },
  },
  {
    option_id: 'card_brand',
    checked: false,
    value: null,
    label: 'Card Brand',
    optionType: 'multi_select',
    optionConfig: {
      options: [
        { value: 'American Express', label: 'American Express' },
        { value: 'MasterCard', label: 'MasterCard' },
        { value: 'Visa', label: 'Visa' },
        { value: 'Diners Club', label: 'Diners Club' },
        { value: 'Discover', label: 'Discover' },
        { value: 'UnionPay', label: 'UnionPay' },
        { value: 'Maestro', label: 'Maestro' },
        { value: 'Elo', label: 'Elo' },
        { value: 'Mir', label: 'Mir' },
        { value: 'Hiper', label: 'Hiper' },
        { value: 'Hipercard', label: 'Hipercard' },
        { value: 'Jcb', label: 'Jcb' },
        { value: 'Electron', label: 'Electron' },
        { value: 'Uatp', label: 'Uatp' },
      ],
    },
  },
  {
    option_id: 'transaction_id',
    checked: false,
    value: null,
    label: 'Transaction ID(s)',
    optionType: 'text',
    optionConfig: {
      conditions: ['is_equal_to'],
    },
  },
  {
    option_id: 'marketplace_id',
    checked: false,
    value: null,
    label: 'Marketplace ID',
    optionType: 'text',
    optionConfig: {
      conditions: ['is_equal_to'],
    },
  },
  {
    option_id: 'customer_id',
    checked: false,
    value: null,
    label: 'Customer ID(s)',
    optionType: 'text',
    optionConfig: {
      conditions: ['is_equal_to'],
    },
  },
  {
    option_id: 'merchant_id',
    checked: false,
    value: null,
    label: 'Merchant ID(s)',
    optionType: 'text',
    optionConfig: {
      conditions: ['is_equal_to'],
    },
  },
  {
    option_id: 'created_on',
    checked: false,
    value: null,
    label: 'Created on',
    optionType: 'date',
    optionConfig: {
      conditions: ['is_in_the_last', 'is_equal_to', 'is_between', 'is_after', 'is_before'],
    },
  },
];

export const filterQueryParams = (searchText: string, filterOptionValues: FilterOption[]): QueryParams => {
  return filterOptionValues.reduce(
    (acc: QueryParams, option) => {
      if (option.checked && option.value && option.value !== null) {
        if (option.option_id === 'event_type') {
          const value = option.value as MultiSelectFilterValue;
          acc['eventType'] = value?.join(',') as string;
        }
        if (option.option_id === 'card_brand') {
          const value = option.value as MultiSelectFilterValue;
          acc['cardBrand'] = value?.join(',') as string;
        }
        if (option.option_id === 'transaction_id') {
          acc['transactionId'] = (option.value as TextFilterValue).text.replace(/\s/g, '');
        }
        if (option.option_id === 'marketplace_id') {
          acc['marketplaceId'] = (option.value as TextFilterValue).text.replace(/\s/g, '');
        }
        if (option.option_id === 'customer_id') {
          acc['customerId'] = (option.value as TextFilterValue).text.replace(/\s/g, '');
        }
        if (option.option_id === 'merchant_id') {
          acc['merchantId'] = (option.value as TextFilterValue).text.replace(/\s/g, '');
        }
        if (option.option_id === 'created_on') {
          const dateValue: DateFilterQueryInput | null = toInstantFilterInput(option.value as DateFilterValue);

          if (dateValue) {
            if ('gt' in dateValue) {
              acc['createdFromInclusive'] = dateValue.gt as string;
            }
            if ('gte' in dateValue) {
              acc['createdFromInclusive'] = dateValue.gte as string;
            }
            if ('lt' in dateValue) {
              acc['createdToExclusive'] = dateValue.lt as string;
            }
            if ('lte' in dateValue) {
              acc['createdToExclusive'] = dateValue.lte as string;
            }
          }
        }
      }
      return acc;
    },
    { last4: searchText },
  );
};
